import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { of, Subscription, tap, filter, catchError } from 'rxjs';

import { AuthUser } from '@shared/signup/models';
import { WhoService } from '../../../services';
import { AuthRestaurantService } from '@tablesready/frontend-store';
import { AlertsService } from '@tablesready/frontend-alerts-bar';

@Component({
  selector: 'tablesready-alerts-settings',
  templateUrl: './alerts-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertsSettingsComponent implements OnInit, OnDestroy {
  alertsSettingsForm: UntypedFormGroup;
  private readonly subscription = new Subscription();

  constructor(
    private readonly alertsService: AlertsService,
    private readonly whoService: WhoService,
    private readonly fb: UntypedFormBuilder,
    private readonly authRestaurantService: AuthRestaurantService,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.authRestaurantService.select()
        .pipe(
          filter(user => user.location !== undefined),
          tap(user => this.setForm(user)),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  submit() {
    const value = this.alertsSettingsForm.value,
      options = {
        arrivesSmsPlayAudio: value.arrivesSmsPlayAudio,
        newPublicCheckInPlayAudio: value.newPublicCheckInPlayAudio,
      };
    this.alertsSettingsForm.markAsPristine();
    this.whoService.updateAlertsSettings(options)
      .pipe(
        tap(response => this.alertsService.addSuccess(response)),
        catchError(error => {
          this.alertsService.addError(`${error.error.error}`);

          return of(null);
        }),
      )
      .subscribe();
  }

  private setForm(user: AuthUser): void {
    this.alertsSettingsForm = this.fb.group({
      arrivesSmsPlayAudio: [user?.location?.alertsSettings?.arrivesSmsPlayAudio || false, Validators.required],
      newPublicCheckInPlayAudio: [user?.location?.alertsSettings?.newPublicCheckInPlayAudio || false, Validators.required],
    });
    this.cdr.detectChanges();
  }
}
